import { render, staticRenderFns } from "./AppLogo.vue?vue&type=template&id=2840e160"
import script from "./AppLogo.vue?vue&type=script&lang=ts"
export * from "./AppLogo.vue?vue&type=script&lang=ts"
import style0 from "./AppLogo.vue?vue&type=style&index=0&id=2840e160&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports